import PropTypes from "prop-types";
import { createContext, useEffect, useState } from "react";
import { useTermsOfUseContext } from "../../hooks/useTermsOfUseContext";
import Search from "./Search";

const initialState = {
  filtersPanel: false,
  foldersPanel: false,
  isOpen: false,
  searchType: "simple", // !!!
};

export const searchContext = createContext(initialState);

const { Provider } = searchContext;

const SearchProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const { isOpen } = state;

  const termsOfUseContext = useTermsOfUseContext();
  const { userMustAcceptTermsOfUse, userMustSetupMfa } = termsOfUseContext;

  useEffect(() => {
    if (isOpen && userMustAcceptTermsOfUse) {
      termsOfUseContext.openDialog();
    }
    else if (isOpen && userMustSetupMfa) {
      termsOfUseContext.openMfaDialog();
    }
  }, [isOpen, userMustAcceptTermsOfUse, userMustSetupMfa]);

  const close = () => {
    setState(prev => ({
      ...prev,
      isOpen: false,
      filtersPanel: initialState.filtersPanel,
      foldersPanel: initialState.foldersPanel,
    }));
  };

  const open = () => {
    setState(prev => ({
      ...prev,
      isOpen: true,
    }));
  };

  const searchType = type => {
    setState(prev => ({
      ...prev,
      searchType: type,
    }));
  };

  const setFiltersPanel = open => {
    setState(prev => {
      if (prev.filtersPanel === open) {
        return prev;
      }

      return {
        ...prev,
        filtersPanel: open,
      };
    });
  };

  const setFoldersPanel = open => {
    setState(prev => {
      if (prev.foldersPanel === open) {
        return prev;
      }

      return {
        ...prev,
        foldersPanel: open,
      };
    });
  };

  const toggleFiltersPanel = () => {
    setState(prev => ({
      ...prev,
      filtersPanel: !prev.filtersPanel,
    }));
  };

  const toggleFoldersPanel = () => {
    setState(prev => ({
      ...prev,
      foldersPanel: !prev.foldersPanel,
    }));
  };

  return (
    <Provider
      value={{
        close,
        filtersPanel: state.filtersPanel,
        foldersPanel: state.foldersPanel,
        open,
        searchType,
        setFiltersPanel,
        setFoldersPanel,
        toggleFiltersPanel,
        toggleFoldersPanel,
      }}
    >
      {isOpen && !userMustAcceptTermsOfUse &&
        <Search onClose={close} />
      }

      {children}
    </Provider>
  );
};

SearchProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SearchProvider;
